<template>
  <!-- 页面主题区域 -->
  <el-container class="tools-body">
    <div class="main-body" v-if="$route.path == '/'">
      <div class="main-title">Token Box</div>
      <div class="main-label">一站式DeFi发币工具</div>
      <div class="main-introduce">
        Simple operation、low price、full chain support、and the most complete currencies
      </div>
      <div class="main-btn" @click="tryItNow()">Try it now</div>
    </div>

    <div class="tools-body2" v-else>
      <div :class="isCollapse ? 'tools-left' : 'tools-left-active'">
        <div class="tools-left-active-bg"></div>

        <!-- 展开/收起 -->
        <div
          v-show="isCollapse"
          @click="isCollapse = false"
          class="tools-expand-retract"
        >
          <div class="expand"></div>
        </div>
        <div
          v-show="!isCollapse"
          @click="isCollapse = true"
          class="tools-expand-retract"
        >
          <div class="retract"></div>
        </div>

        <!-- 侧边栏 -->
        <el-aside class="tools-aside">
          <!--侧边栏菜单区域-->
          <el-menu
            class="el-menu-vertical-demo"
            @open="handleOpen"
            @close="handleClose"
            
            background-color="transparent"
            text-color="#BCBCBC"
            active-text-color="#675AFF"

            :collapse-transition="true"
            :collapse="isCollapse"
            :unique-opened="true"

            :default-active="this.$route.path"
          >
            <el-menu-item
              :index="'/'+ item.path"
              v-for="(item, index) in menulist"
              :key="index"
              @click.native="saveNavState('/' + item.path)"
            >
              <img v-if="$route.path=='/'+ item.path" :src="item.iconActive" class="icon" alt/>
              <img v-else :src="item.icon" class="icon" alt/>
              <span slot="title">{{ item.name }}</span>
            </el-menu-item>
          </el-menu>
        </el-aside>
      </div>

      <!-- 右侧内容主体 -->
      <el-main class="tools-main">
        <!--路由占位符-->
        <router-view v-if="isRouterAlive" class="tools-router"></router-view>
      </el-main>
    </div>
  </el-container>
</template>


<script>
import { modeConfigs } from "../../config/config.js";
export default {
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      selectedIconIndex: 0,
      // 导航栏状态
      isCollapse: false,
      // 路由占位符
      isRouterAlive: true,
      // 左侧菜单数据
      menulist:modeConfigs,
      // 被激活的链接地址
      activePath: this.$route.path,
      // 子菜单默认展开
      openeds: ["0"],
      // 语言
      languageValue: 0,
      // token
      token: 0,
      // 提示弹框显示
      alertDialogVisible: true,
    };
  },
  components: {},
  beforeMount() {},
  mounted() {},
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    // 保存链接的激活状态
    saveNavState(activePath) {
      window.sessionStorage.setItem("activePath", activePath);
      this.activePath = activePath;
      this.$router.push(activePath);
    },
    tryItNow() {
      this.$router.push('/stardand');
    }
  },
  computed: {},
  watch: {},
};
</script>
<style lang="scss" scoped>
.tools-body {
  position: relative;
  height: 100%;
  width: 100%;
  min-height: calc(100vh - 60px);
  margin: 0 0 0 0;
  background: rgba(0, 0, 0, 1);

  .tools-body2 {
    width: 100%;
    height: 100%;
    display: flex;
    margin: 60px 0 0 0;

    .tools-left-active {
      position: relative;
      width: 246px;
      height: calc(100vh - 100px);
      background: linear-gradient(
        180deg,
        #080344 0%,
        #000000 35%,
        #222222 100%
      );
      border-radius: 0px 20px 20px 0px;
      border-image: linear-gradient(
          264deg,
          rgba(40, 40, 40, 1),
          rgba(0, 0, 0, 1)
        )
        1 1;

      overflow: hidden;
      margin: 20px 0 0 0;

      .tools-left-active-bg {
        position: absolute;
        width: 246px;
        height: calc(100vh - 100px);
        background-image: url("~@/assets/images/menu_bg.png");
        background-size: contain;
        background-position: center center;
        background-repeat: no-repeat;
      }

      .tools-expand-retract {
        position: absolute;
        width: calc(100% - 13px);
        height: 25px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin: 13px 13px 13px 0;

        .expand {
          width: 25px;
          height: 24px;

          background-image: url("~@/assets/images/expand.png");
          background-position: center center;
          background-size: contain;
          background-repeat: no-repeat;

          cursor: pointer;
        }
        .expand:hover {
          background-image: url("~@/assets/images/expand_hover.png");
        }

        .retract {
          width: 24px;
          height: 25px;

          background-image: url("~@/assets/images/retract.png");
          background-position: center center;
          background-size: contain;

          cursor: pointer;
        }
        .retract:hover {
          background-image: url("~@/assets/images/retract_hover.png");
        }
      }

      .tools-aside {
        position: absolute;
        top: 51px;
        overflow: auto;
        width: 246px !important;
        height: calc(100% - 95px);
        
        .icon {
          width: 25px;
          height: 25px;
          object-fit: contain;
          margin: 0 20px 0 0;
        }
      }
    }

    .tools-left {
      width: 64px;
      height: calc(100vh - 80px);
      background: linear-gradient(
        180deg,
        #080344 0%,
        #000000 35%,
        #222222 100%
      );
      border-radius: 0px 20px 20px 0px;
      border-image: linear-gradient(
          264deg,
          rgba(40, 40, 40, 1),
          rgba(0, 0, 0, 1)
        )
        1 1;

      overflow: hidden;
      margin: 20px 0 0 0;

      .tools-expand-retract {
        width: calc(100%);
        height: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 13px 0 13px 0;

        .expand {
          width: 25px;
          height: 24px;

          background-image: url("~@/assets/images/expand.png");
          background-position: center center;
          background-size: contain;
          background-repeat: no-repeat;

          cursor: pointer;
        }
        .expand:hover {
          background-image: url("~@/assets/images/expand_hover.png");
        }

        .retract {
          width: 24px;
          height: 25px;
          background-image: url("~@/assets/images/retract.png");
          background-position: center center;
          background-size: contain;
          cursor: pointer;
        }
        .retract:hover {
          background-image: url("~@/assets/images/retract_hover.png");
        }
      }

      .tools-aside {
        position: absolute;
        top: auto;
        overflow: auto;
        width: 64px !important;
        height: calc(100% - 95px);

        .icon {
          width: 25px;
          height: 25px;
          object-fit: contain;
          margin: 0 20px 0 0;
        }
      }
      ::-webkit-scrollbar {
        width: 0px; /* 设置滚动条的宽度 */
        height: 10px; /* 设置滚动条的高度 */
      }
    }

    .tools-main {
      width: calc(100% - 246px);
      height: calc(100vh - 60px);
      overflow: hidden;

      .tools-router {
        overflow: auto;
        display: flex;
        justify-content: center;
      }
    }
  }

  .main-body {
    height: 100%;
    width: 100%;
    min-height: calc(100vh);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    background-image: url('~@/assets/images/main_bg.png');
    background-position: center center;
    background-size: cover;

    .main-title {
      font-weight: bold;
      font-size: 80px;
      color: #ffffff;
      line-height: 94px;
      text-align: center;
      font-style: normal;
      text-transform: none;

      margin: 0 0 28px 0;
    }

    .main-label {
      font-weight: normal;
      font-size: 26px;
      color: #ffffff;
      line-height: 30px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin: 0 0 35px 0;
    }

    .main-introduce {
      font-weight: normal;
      font-size: 18px;
      color: #ffffff;
      line-height: 21px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      margin: 0 0 62px 0;
    }

    .main-btn {
      width: 200px;
      height: 60px;
      border-radius: 40px 40px 40px 40px;
      background: transparent;
      border: 1px solid #747474;

      font-weight: normal;
      font-size: 18px;
      color: #747474;
      line-height: 60px;
      text-align: center;
      font-style: normal;
      text-transform: none;

      cursor: pointer;
    }

    .main-btn:hover {
      background: #695CFF;
      box-shadow: 0px 10px 130px 40px rgba(105,92,255,0.7);
      border-radius: 40px 40px 40px 40px;
      border: 1px solid;
      color: #FFFFFF;
    }
  }
}

/deep/.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 236px;
}
/deep/.el-submenu__title:hover {
  background: rgba(77, 77, 77, 0.5) !important;
  // color: #d8d8d8 !important;
}
/deep/.el-menu-item:hover {
  background: rgba(77, 77, 77, 0.5) !important;
  // color: #d8d8d8 !important;
}
/deep/.el-menu {
  border: none;
}
/deep/.el-icon-location {
  margin: 0 20px 0 0 !important;
}
/deep/.el-menu-item [class^="el-icon-"] {
  margin: 0 20px 0 0 !important;
}

/* 为所有滚动条设置样式 */
::-webkit-scrollbar {
  width: 6px; /* 设置滚动条的宽度 */
  height: 10px; /* 设置滚动条的高度 */
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
  background: transparent; /* 设置轨道的背景颜色 */
}

/* 滚动条的滑块 */
::-webkit-scrollbar-thumb {
  background: #888; /* 设置滑块的背景颜色 */
  border-radius: 5px 5px;
}

/* 当鼠标悬停在滑块上 */
::-webkit-scrollbar-thumb:hover {
  background: #555; /* 设置滑块在悬停状态下的背景颜色 */
  cursor: pointer;
}
</style>